<template>
    <card-seplag titulo="Escala Anual de Licença Prêmio">

        <Panel header="Ação" class="p-col-12" v-if="!mostrarNaoAgendados" style="margin-top:10px">            
            <div class="p-grid p-col-12  p-align-center p-justify-center">
                <!-- botões: Imprimir Escala | Gerar Processo | Fechar Escala -->
                <div class="p-md-3 p-col-12" v-if="mostrarDeferidos">
                    <Button label="Gerar Processo" icon="pi pi-cog" class="p-button-secondary botao-acao" @click="showModalGerarProcesso()" :disabled='!habilitaAgendamento'/>
                </div>
                <div class="p-md-3 p-col-12" v-if="this.mostrarDeferidos">
                    <Button label="Encerrar Escala" icon="pi pi-lock" class="p-button-secondary botao-acao" @click="fecharEscala = !fecharEscala" :disabled='!habilitaAgendamento'/>
                </div>
                <div class="p-md-3 p-col-12" >
                    <Button label="Imprimir Escala" icon="pi pi-print" class="p-button-secondary botao-acao" />
                </div>
            </div>
            <div class="p-grid p-align-center p-justify-center" v-if="fecharEscala && habilitaAgendamento">
                <Rotulo cols="12 2" nome="Número D.O">
                    <InputText type="text"  v-model="escala.numrDo"/>
                </Rotulo>
                <Rotulo cols="12 2" nome="Página">
                    <InputText type="text" v-model="escala.numrPaginaDo"  />
                </Rotulo>
                <Rotulo cols="12 2" nome="Data Publicação">
                    <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa"  :disabled='!habilitaAgendamento' v-model="escala.dataPublicacaoDo"/>
                </Rotulo>      
                <div class="p-col-12"></div>
                <div class="p-md-3 p-col-12">
                    <Button label="Salvar" icon="pi pi-check" class="p-button-success botao-acao" :disabled='!habilitaAgendamento' @click="encerrarEscala()"/>
                </div>                 
                <div class="p-md-3 p-col-12">
                    <Button label="Fechar" icon="pi pi-trash" class="p-button-danger botao-acao" @click="fecharEscala = !fecharEscala" :disabled='!habilitaAgendamento'/>
                </div>
            </div>
        </Panel>    

        <div class="p-grid p-col-12" style="margin-top:10px;">
            <div class="p-md-3 p-col-12"  @click="alternarPaginas('pendentes')" >
                <!-- botões legenda: Pendentes | Deferidos | Não agendados -->                
                <Card class="card-button estiloPendentes" v-if="mostrarPendentes">
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Pendentes</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countPendentes).slice(this.countPendentes.toString().split('').length> 3? "-"+this.countPendentes.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
                <Card class="card-button" v-else>
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Pendentes</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countPendentes).slice(this.countPendentes.toString().split('').length> 3? "-"+this.countPendentes.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
            </div>
            <div class="p-md-3 p-col-12"  @click="alternarPaginas('deferidos')">  
                <Card class="card-button estiloDeferidos" v-if="mostrarDeferidos">
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Validados</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countDeferidos).slice(this.countDeferidos.toString().split('').length> 3? "-"+this.countDeferidos.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
                <Card class="card-button" v-else>     
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Validados</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countDeferidos).slice(this.countDeferidos.toString().split('').length> 3? "-"+this.countDeferidos.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
            </div>
            <div class="p-md-3 p-col-12" @click="alternarPaginas('naoAgendados')">
                <Card class="card-button estiloNaoAgendados" v-if="mostrarNaoAgendados">
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Não Agendados</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countNaoAgendados).slice(this.countNaoAgendados.toString().split('').length> 3? "-"+this.countNaoAgendados.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
                <Card class="card-button" v-else>
                    <template slot="content">    
                        <div class="p-grid">
                            <div class="p-col-7">
                                <span class="botao-titulo-status">Não Agendados</span>
                            </div>
                            <div class="p-offset-2 p-col-2">
                                <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countNaoAgendados).slice(this.countNaoAgendados.toString().split('').length> 3? "-"+this.countNaoAgendados.toString().split('').length:-3)}}</span>
                            </div>
                        </div>                    
                    </template>
                </Card>
            </div>
            <div class="p-md-3 p-col-12" @click="alternarPaginas('publicadoseap')">
                <Card class="card-button estiloPublicoSEAP" v-if="mostrarPublicadoseap">
                <template slot="content">
                    <div class="p-grid">
                    <div class="p-col-7">
                        <span class="botao-titulo-status">NO SEAP</span>
                    </div>
                    <div class="p-offset-2 p-col-2">
                        <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countPublicadoseap).slice(this.countPublicadoseap.toString().split('').length> 3? "-"+this.countPublicadoseap.toString().split('').length:-3)}}</span>
                    </div>
                    </div>
                </template>
                </Card>
                <Card class="card-button" v-else>
                <template slot="content">
                    <div class="p-grid">
                    <div class="p-col-7">
                        <span class="botao-titulo-status">NO SEAP</span>
                    </div>
                    <div class="p-offset-2 p-col-2">
                        <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countPublicadoseap).slice(this.countPublicadoseap.toString().split('').length> 3? "-"+this.countPublicadoseap.toString().split('').length:-3)}}</span>
                    </div>
                    </div>
                </template>
                </Card>
            </div>
        </div>

        <Panel :header="'Busca nos ' + textoBusca" class="p-col-12">
        <div class="p-grid p-align-center p-justify-center">
            <Rotulo cols="12 2" nome="Periodo">
            <Dropdown
                v-model="dadosBusca.tipoBuscaData"
                :options="tipoPesquisaDataEnum"
                optionLabel="name"
                optionValue="code"
                placeholder="Selecione..."
            />
            </Rotulo>
            <Rotulo cols="12 2" nome="Data" >
                <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="dadosBusca.dataBusca" />
            </Rotulo>
            <Rotulo cols="12 2" nome="Mês">
            <Dropdown
                v-model="dadosBusca.mesFiltro"
                :options="listaMeses"
                optionLabel="name"
                optionValue="value"
                placeholder="Selecione..."
                showClear
            />
            </Rotulo>
            <Rotulo cols="12 2" nome="Busca Nome/matrícula/setor" >
            <InputText type="text" v-model="dadosBusca.parametroPesquisa" v-on:keyup.enter="buscaServidor()" />
            </Rotulo>
            <div class="p-md-2 p-col-12">
            <label style="padding: 10px"> </label>
            <Button
                label="Buscar"
                icon="pi pi-search"
                class="p-button-info"
                @click="buscaServidor()"
            />
            </div>
        </div>
        </Panel>
        
        <div class="p-col-12" v-if="dadosTabela.length > 0">
            <table-seplag 
                :dados="dadosTabela" 
                :exibirCabecalho="false" 
                :campos="[]" 
                :paginacao="true"
                :onSearchPaginacao="carregarDadosAgendamento" 
                :totalRegistro="totalRecords">    
                    <Column field="idenProgramacaoAfastamento" header="ID">
                        <template #body="slotProps">
                        <p>{{slotProps.data.idenProgramacaoAfastamento?slotProps.data.idenProgramacaoAfastamento:slotProps.data.idenDireitoAfastamento?slotProps.data.idenDireitoAfastamento: ''}}</p>
                        </template>
                    </Column>    
                    <Column field="numrMatricula" header="Matrícula">
                        <template #body="slotProps">
                        <p>{{slotProps.data.numrMatricula}}</p>
                        </template>
                    </Column>  
                    <Column field="nomeServidor" header="Nome Servidor" :bodyStyle="{width: '40%'}">
                        <template #body="slotProps">
                        <p>{{slotProps.data.nomeServidor}}<br /><span style="font-size: 11px;font-weight: 700;">{{slotProps.data.nomeSetor}}</span></p>
                        </template>
                    </Column>  
                    <Column field="dataInicioPeriodaAquisitivo" header="Periodo Aquisitivo"  headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento"  >
                        <template #body="slotProps">
                        <span> {{slotProps.data.dataInicioPeriodaAquisitivo}}<br />{{slotProps.data.dataFimPeriodaAquisitivo}}</span>
                        </template>
                    </Column>  
                    <Column field="dataInicio" header="Periodo de Usufruto"  headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento"    v-if="mostrarPendentes || mostrarDeferidos">
                        <template #body="slotProps">
                        <span> {{slotProps.data.dataInicio}}<br />{{slotProps.data.dataFim}}</span>
                        </template>
                    </Column>  
                    <Column field="qtdDiasAfastamento" header="Dias Solicitados"  headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento"   v-if="mostrarPendentes || mostrarDeferidos">
                        <template #body="slotProps">
                        <span> {{slotProps.data.qtdDiasAfastamento}}</span>
                        </template>
                    </Column>    
                    <Column field="qtdeSaldoDias" header="Saldo de Dias"  headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento"   v-else-if="mostrarNaoAgendados">
                        <template #body="slotProps">
                        <span> {{slotProps.data.qtdeSaldoDias}}</span>
                        </template>
                    </Column>    
                    <Column field="status" header="Situação"  headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento"  v-if="mostrarPendentes || mostrarDeferidos">
                        <template #body="slotProps">
                            <span :class="'customer-badge status-' + slotProps.data.statusProgramacao">{{slotProps.data.statusProgramacao=='APROVADORH'? 'APROVADO' : slotProps.data.statusProgramacao}}</span> <br/>                    
                            <span><b>{{slotProps.data.statusProgramacaoDesc}}</b></span>  <br/>                         
                            <span class="estiloPendentesReduzido" v-if="slotProps.data.tipoJornada=='REDUZIDA'">(<b>Redução de Jornada</b>)</span>
                            <span v-if="slotProps.data.tipoJornada=='INTEGRAL'">(<b>Usufruto</b>)</span>
                        </template>
                    </Column>      
                    <Column field="status" header="Situação"  headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento"  v-else-if="mostrarNaoAgendados">
                        <template #body="slotProps">
                            <span :class="'customer-badge status-' + slotProps.data.statusAfastamento">{{slotProps.data.statusAfastamento}}</span><br/>         
                            <span><b>{{slotProps.data.statusAfastamentoDesc}}</b></span>                        
                        </template>
                    </Column>                 
                    <Column headerStyle="width: 6em"  bodyStyle="text-align: center;"  header="Ação" v-if="mostrarPendentes || mostrarDeferidos" >
                    <template #body="slotProps">
                        <Button
                        type="button"
                        icon="pi pi-id-card"
                        v-tooltip.top="'Ação'"
                        @click="showModal(slotProps.data)"
                        :disabled="!habilitaAgendamento"
                        ></Button>                    
                        <Button
                        type="button"
                        class="p-button-success"
                        icon="pi pi-check"
                        v-tooltip.top="'No SEAP'"
                        style="margin-left: 3px;"
                        @click="alteraStatusProgramacao(slotProps.data)"
                        v-if="mostrarDeferidos"
                        ></Button>
                    </template>
                    </Column>         
                    <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação" v-else-if="mostrarNaoAgendados" >
                    <template #body="slotProps">
                        <Button
                        type="button"
                        icon="pi pi-id-card"
                        v-tooltip.top="'Ação'"
                        @click="showModalDataFerias(slotProps.data)"
                        :disabled="!habilitaAgendamento"
                        ></Button>
                    </template>
                    </Column>   
                    <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação" v-else-if="mostrarPublicadoseap" >
                    <template #body="slotProps">                                  
                        <Button
                        type="button"
                        class="p-button-warning"
                        icon="pi pi-replay"
                        v-tooltip.top="'Voltar Para Validado'"
                        style="margin-left: 3px;"
                        @click="alteraStatusProgramacao(slotProps.data,'aprovados')"
                        ></Button>
                    </template>
                    </Column> 
            </table-seplag>   
        </div>

        <cadastro-rapido v-if="habilitaAgendamento"  tituloTela="Gerar Processo" tamanhoTela='40.vw' v-model="exibirTelaGerarProcesso" :modoEdicao="'adicionar'"   :onAdicionar="gerarProcessoSigadoc" textoButton="Gerar" optionValue="code">
            <Rotulo nome="Login Cadastrante  do Sigadoc" cols="12 6" >
                <InputText type="text" v-model="registroProcesso.usuarioSigadoc" />              
            </Rotulo>      
            <Rotulo nome="Login Subscritor do Sigadoc" cols="12 6" >
                <InputText type="text" v-model="registroProcesso.subscritorSigadoc" />              
            </Rotulo>   
            <Rotulo nome="Artigo (O ou A) + Cargo do Gestor do Órgão/Entidade" cols="12" >
                <InputText type="text" v-model="registroProcesso.cargoMaximo" />              
            </Rotulo>   
            <Rotulo nome="Ano Escala" cols="12 6" >
                <InputText type="number" v-model="registroProcesso.anoEscala" />              
            </Rotulo>   
            <Rotulo nome="Sigla do Orgao" cols="12 6" >
                <InputText type="text" v-model="registroProcesso.siglaOrgao" />              
            </Rotulo>     
        </cadastro-rapido>

        <cadastro-rapido v-if="habilitaAgendamento"  :tituloTela="mostrarDeferidos? 'Indeferir Licença' : 'Definir Ação'" v-model="exibirTelaValidacaoPendente" :modoEdicao="'adicionar'"  :onAdicionar="validaRegistro" optionValue="code" :textoButton="mostrarDeferidos? 'Indeferir' : 'Salvar'">
            <div class="p-col-12">
                <Fieldset >
                    <template #legend>
                        <strong>Servidor</strong>
                    </template>
                    <p><strong>Matricula: </strong> {{dadosAprovacao && dadosAprovacao.numrMatricula?dadosAprovacao.numrMatricula : ""}}</p>
                    <p><strong>Candidato: </strong> {{dadosAprovacao && dadosAprovacao.nomeServidor?dadosAprovacao.nomeServidor : ""}}</p>
                    <p><strong>Data Início: </strong> {{dadosAprovacao && dadosAprovacao.dataInicio?dadosAprovacao.dataInicio : ""}}</p>
                    <p><strong>Data Fim: </strong> {{dadosAprovacao && dadosAprovacao.dataFim?dadosAprovacao.dataFim : ""}}</p>
                </Fieldset>
            </div>
            <Rotulo nome="Deferir?" cols="12" v-if="!mostrarDeferidos" >
                <SelectButton name='deferido' v-model="registro.statusProgramacao.idenStatusProgramacao" :options="simNao" optionLabel="name"  v-required />
            </Rotulo>
            <Rotulo nome="Justificativa" cols="12" >
                <Textarea v-model="registro.descJustificativa"  rows="5" cols="30" />
            </Rotulo>
        </cadastro-rapido>
        
        <cadastro-rapido v-if="habilitaAgendamento"  tituloTela="Cadastro de Datas de Licença" :tamanhoTela="'69.vw'" v-model="exibirTelaNovaFerias" :modoEdicao="'adicionar'"  :onAdicionar="adicionarRegistro" optionValue="code" :textoButton="'Salvar'">
            <div class="p-col-12">
                <Fieldset >
                    <template #legend>
                        <strong>Servidor</strong>
                    </template>
                    <p><strong>Matricula: </strong> {{dadosFerias && dadosFerias.numrMatricula?dadosFerias.numrMatricula : ""}}</p>
                    <p><strong>Candidato: </strong> {{dadosFerias && dadosFerias.nomeServidor?dadosFerias.nomeServidor : ""}}</p>
                    <p><strong>Periodo Aquisitivo: </strong> {{dadosFerias && dadosFerias.dataInicioPeriodaAquisitivo?dadosFerias.dataInicioPeriodaAquisitivo : ""}} - {{dadosFerias && dadosFerias.dataFimPeriodaAquisitivo?dadosFerias.dataFimPeriodaAquisitivo : ""}}</p>
                </Fieldset>
            </div>
            
            <Rotulo nome="Dias de usufruto" cols="12" >
                <SelectButton v-model="selectedTipoGozo" :options="tiposGozo" optionLabel="name" @input="calcularData()" />                
            </Rotulo>          
            <Rotulo nome="Converter em redução de jornada?" class="p-align-center p-justify-center" cols="12" style="text-align:center" v-if="selectedTipoGozo && selectedTipoGozo.code>=30" >                            
                <InputSwitch v-model="checkReducaoJornada"  @input="calcularData()" />
                <div v-if="this.checkReducaoJornada==true">Sim</div>
                <div v-if="this.checkReducaoJornada==false">Não</div>
            </Rotulo>
            <Rotulo name=""  cols="12 2"  style="margin-top: 1.8%;">
                <div style="background-color:#b7d8b7; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==10 && this.checkReducaoJornada==false"><b>10</b> dias corridos</div>
                <div style="background-color:#b7d8b7; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==10 && this.checkReducaoJornada==true"><b>20</b> dias corridos</div>
                <div style="background-color:#7fbcec; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==15 && this.checkReducaoJornada==false"><b>15</b> dias corridos</div>
                <div style="background-color:#b7d8b7; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==15 && this.checkReducaoJornada==true"><b>30</b> dias corridos</div>
                <div style="background-color:#ffe399; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==20 && this.checkReducaoJornada==false"><b>20</b> dias corridos</div>
                <div style="background-color:#ffe399; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==20 && this.checkReducaoJornada==true"><b>40</b> dias corridos</div>                          
                <div style="background-color:#b7d8b7; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==30 && this.checkReducaoJornada==false"><b>30</b> dias corridos</div>
                <div style="background-color:#b7d8b7; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==30 && this.checkReducaoJornada==true"><b>60</b> dias corridos</div>
                <div style="background-color:#7fbcec; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==60 && this.checkReducaoJornada==false"><b>60</b> dias corridos</div>
                <div style="background-color:#7fbcec; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==60 && this.checkReducaoJornada==true"><b>120</b> dias corridos</div>
                <div style="background-color:#ffe399; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==90 && this.checkReducaoJornada==false"><b>90</b> dias corridos</div>
                <div style="background-color:#ffe399; text-align:center;padding:6px"  v-if="selectedTipoGozo && selectedTipoGozo.code==90 && this.checkReducaoJornada==true"><b>180</b> dias corridos</div>
            </Rotulo>
            <Rotulo nome="Data de início" id="integral_inicio" cols="12 5"  v-if="selectedTipoGozo">
                <v-date-picker v-model="data_inicio" @input="calcularData()" :max-date='max_date' :min-date='min_date' :model-config="datePikerConfig"  :update-on-input="false" :masks="datePikermasks"> 
                    <template v-slot="{ inputValue, inputEvents}">
                        <input
                        class="p-inputmask p-inputtext p-component "
                        :value="inputValue"
                        v-on="inputEvents"
                        />
                    </template>
                </v-date-picker>
                <!-- <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="data_inicio" @input="calcularData()" /> -->
            </Rotulo>
            <Rotulo nome="Data de término" id="integral_fim" cols="12 4"  v-if="selectedTipoGozo">
                <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="data_fim"  disabled="true" />
            </Rotulo>
        </cadastro-rapido>    
        
        <div class="p-md-3 p-col-12" >
            <Button label="Voltar" icon="pi pi-arrow-left" @click="voltarPagina()" class="p-button-secondary"/>
        </div>
    </card-seplag>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import TableSeplag from '@/template/TableSeplag.vue';
import CadastroRapido from '@/template/CadRapidoSeplag.vue'
import Column from 'primevue/column';
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'
import { simNao } from '@/config/global'
import moment from 'moment'
const getDefaulValida = () => {
    return {  
        direitoAfastamento: {
            idenDireitoAfastamento: null
        },
        descJustificativa: "",
        numrMatriculaChefe: null,
        numrVinculoChefe: null,
        statusProgramacao: {
            idenStatusProgramacao: {name: 'Sim', code: "S"}
        }
    }
}

const getDefaulGerarProcesso = () => {
    return {  
        tipoAfastamento:'licencapremio',
        matricula: null,
        vinculo: null,
        idenPessoa: null,
        usuarioSigadoc: null,
        subscritorSigadoc: null,
        cargoMaximo: null,
        anoEscala: null,
        siglaOrgao: null,
        idenEscalaAfastamento: null
    }
}
export default {
    name: 'escalaAnualLicencaPremioRh',
    components: { CardSeplag, TableSeplag, Column, Rotulo, CadastroRapido },
    data(){
        return{
            apiUrlRecurso:"",
            mostrarPendentes:false,
            mostrarDeferidos:false,
            mostrarNaoAgendados:false,
            mostrarPublicadoseap: false,
            countPendentes:0,
            countDeferidos:0,
            countNaoAgendados:0,
            countPublicadoseap: 0,
            tituloTabela: "",
            dadosAgendamentosPorSetor:[],
            dadosTabela:[],
            mostrarJson:[],
            expandedRows : null,
            layout:"list",
            
            registro: getDefaulValida(),
            dadosAprovacao: [],
            simNao: simNao,
            exibirTelaValidacaoPendente: false,

            exibirTelaNovaFerias: false,
            selectedTipoGozo:null,
            dadosFerias: null,
            
            tipoPesquisaDataEnum: [
                { name: 'Período Aquisitivo', code: 'PEREODOAQUISITIVO' },
                { name: 'Período de Usufruto', code: 'PERIODOUSUFRUTO' },
                { name: 'Todos os Período', code: 'TODO' }
            ],
            tiposGozo: [
                {name:"10 dias",code: 10},
                {name:"15 dias",code: 15},
                {name:"20 dias",code: 20},
            ],
            data_inicio : null,
            data_fim : null,
            checkReducaoJornada: false,

            fecharEscala: false,

            dadosBusca: {
                dataBusca: null,
                tipoBuscaData: 'TODO',
                parametroPesquisa: null,
                mesFiltro: null
            },
            buscaAtiva: false, 
            msgErroBusca: [
                {
                    msg: "Não foi encontrado nenhum servidor nessa busca"
                }
            ],
            
            datePikerConfig: {
                type: 'string',
                mask: 'DD/MM/YYYY', 
            },
            
            datePikermasks: {
                input: 'DD/MM/YYYY',
            },
            
            registroProcesso: getDefaulGerarProcesso(),
            exibirTelaGerarProcesso: false,
            habilitaAgendamento: true,
            escalaAnualRhSelecionada: null,
            escala: null,
            totalRecords: 0,

            listaMeses:[
                {name: 'Janeiro', value: '1'},
                {name: 'Fevereiro', value: '2'},
                {name: 'Março', value: '3'},
                {name: 'Abril', value: '4'},
                {name: 'Maio', value: '5'},
                {name: 'Junho', value: '6'},
                {name: 'Julho', value: '7'},
                {name: 'Agosto', value: '8'},
                {name: 'Setembro', value: '9'},
                {name: 'Outubro', value: '10'},
                {name: 'Novembro', value: '11'},
                {name: 'Dezembro', value: '12'},

            ]
        }
    },
    methods:{
        async carregarDados(){            
            this.escala = this.$store.getters.getEscalaAnualRhSelecionada? this.$store.getters.getEscalaAnualRhSelecionada : null;
            if(!this.escala){
                this.$router.push({name:'cadEscala'})
            }else{
                this.dadosTabela =  []
                this.matricula  = await this.$store.getters.getMatricula
                this.vinculo = await this.$store.getters.getVinculo
                this.idenPessoa = await this.$store.getters.getIdenPessoa
                this.escalaAnualRhSelecionada = this.$store.getters.getEscalaAnualRhSelecionada? this.$store.getters.getEscalaAnualRhSelecionada.idenEscalaAfastamento: null;
                this.habilitaAgendamento = this.$store.getters.getEscalaAnualRhSelecionada && this.$store.getters.getEscalaAnualRhSelecionada.situacao=='ENCERRADO'? false : true;
                var options = {
                    tipoAfastamento: "licencapremio",
                    matricula: this.matricula,
                    vinculo: this.vinculo,
                    idenPessoa: this.idenPessoa,
                    idenEscalaAfastamento: this.escalaAnualRhSelecionada
                }

                /*
                    carrega os contadores dos botões "Pendentes", "Deferidos" e "Não agendados"
                */
                var v_countP = await this.$http.post(`${baseApiUrl}/programacaoafastamentos/rh/count/pendentes`, JSON.stringify(options))
                if(v_countP.status==200){
                    this.countPendentes = v_countP.data
                }

                var v_countD = await this.$http.post(`${baseApiUrl}/programacaoafastamentos/rh/count/aprovados`, JSON.stringify(options))
                if(v_countD.status==200){
                    this.countDeferidos = v_countD.data
                }
      
                var v_countPSEAP = await this.$http.post(`${baseApiUrl}/programacaoafastamentos/rh/count/publicadoseap`, JSON.stringify(options))
                if(v_countPSEAP.status==200){
                    this.countPublicadoseap = v_countPSEAP.data
                }

                var v_countNA = await this.$http.post(`${baseApiUrl}/direitoafastamentos/rh/count/naoagendados`, JSON.stringify(options))
                if(v_countNA.status==200){
                    this.countNaoAgendados = v_countNA.data
                }

                
                if(new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY') < new moment()){
                    this.data_inicio = new moment().add(31,'day').format('DD/MM/YYYY')
                    this.min_date = new moment().add(31,'day').format()
                    this.max_date = new moment().add(31,'day').add(1,'year').format()
                    this.calcularData();
                }else{
                    this.data_inicio = new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY').format('DD/MM/YYYY')
                    this.min_date = new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY').format()
                    this.max_date =  new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY').add(1,'year').format()
                    this.calcularData();
                }

                /*
                    Carrega dados de acordo com o status selecionado
                */
                var urlSetores = ""
                this.apiUrlRecurso = "programacaoafastamentos"

                if(this.mostrarPendentes){
                    urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/pendentes/${this.escalaAnualRhSelecionada}?size=10&page=0`, JSON.stringify(this.dadosBusca))
                } else if(this.mostrarDeferidos){
                    urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/aprovados/${this.escalaAnualRhSelecionada}?size=10&page=0`, JSON.stringify(this.dadosBusca))
                } else if (this.mostrarPublicadoseap) {
                    urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/publicadoseap/${this.escalaAnualRhSelecionada}?size=10&page=0`,JSON.stringify(this.dadosBusca));
                } else if(this.mostrarNaoAgendados){
                    this.apiUrlRecurso = "direitoafastamentos"
                    urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/naoagendados/${this.escalaAnualRhSelecionada}?size=10&page=0`, JSON.stringify(this.dadosBusca))
                }

                var v_setores = await urlSetores
                if(v_setores.status==200) {
                    this.dadosTabela = v_setores.data.content;
                    this.totalRecords =  v_setores.data.totalElements
                }
            }
            
        },
        async carregarDadosAgendamento(size=10,page=0){

            var urlSetores = ""
            this.apiUrlRecurso = 'programacaoafastamentos';

            if (this.mostrarPendentes) {        
                urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/pendentes/${this.escalaAnualRhSelecionada}?size=${size}&page=${page}`,JSON.stringify(this.dadosBusca));
            } else if (this.mostrarDeferidos) {
                urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/aprovados/${this.escalaAnualRhSelecionada}?size=${size}&page=${page}`,JSON.stringify(this.dadosBusca));
            } else if (this.mostrarPublicadoseap) {
                    urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/publicadoseap/${this.escalaAnualRhSelecionada}?size=${size}&page=${page}`,JSON.stringify(this.dadosBusca));
            } else if (this.mostrarNaoAgendados) {
                this.apiUrlRecurso = 'direitoafastamentos';
                urlSetores = this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/naoagendados/${this.escalaAnualRhSelecionada}?size=${size}&page=${page}`,JSON.stringify(this.dadosBusca));
            }      

            let v_setores = await urlSetores;

            if (v_setores.status == 200) {
                this.dadosTabela = v_setores.data.content;
                this.totalRecords =  v_setores.data.totalElements
            }      


        },
        alternarPaginas(click){            
            this.dadosBusca = {
                dataBusca: null,
                tipoBuscaData: 'TODO',
                parametroPesquisa: null,
                mesFiltro: null
            }
            if (click == 'pendentes') {
                this.mostrarNaoAgendados = false;
                this.mostrarDeferidos = false;
                this.mostrarPublicadoseap = false;
                this.mostrarPendentes = true;
                this.tituloTabela = 'Agendamentos Pendentes';
            } else if (click == 'deferidos') {        
                this.mostrarNaoAgendados = false;
                this.mostrarPendentes = false;
                this.mostrarPublicadoseap = false;
                this.mostrarDeferidos = true;
                this.tituloTabela = 'Agendamentos Deferidos';
            } else if (click == 'naoAgendados') {        
                this.mostrarDeferidos = false;
                this.mostrarPendentes = false;
                this.mostrarPublicadoseap = false;
                this.mostrarNaoAgendados = true;
                this.tituloTabela = 'Não Agendados';
            } else if (click == 'publicadoseap') {        
                this.mostrarDeferidos = false;
                this.mostrarPendentes = false;
                this.mostrarNaoAgendados = false;
                this.mostrarPublicadoseap = true;
                this.tituloTabela = 'No SEAP';
            }
            
            this.carregarDados()
        },            
        limparDados(){
            this.selectedTipoGozo = null;
            this.dadosFerias =  null;
            this.data_fim = null;         
            if(new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY') < new moment()){
                this.data_inicio = new moment().add(31,'day').format('DD/MM/YYYY')
                this.min_date = new moment().add(31,'day').format()
                this.max_date = new moment().add(31,'day').add(1,'year').format()
            }else{
                this.data_inicio = new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY').format('DD/MM/YYYY')
                this.min_date = new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY').format()
                this.max_date =  new moment(this.escala.dataInicioAgendamento,'DD/MM/YYYY').add(1,'year').format()
            }

        },
        gerarProcessoSigadoc(){

            this.registroProcesso.matricula = this.$store.getters.getMatricula            
            this.registroProcesso.vinculo= this.$store.getters.getVinculo     
            this.registroProcesso.idenPessoa = this.$store.getters.getIdenPessoa
            this.registroProcesso.idenEscalaAfastamento = this.escalaAnualRhSelecionada

            this.$http.post(`${baseApiUrl}/direitoafastamentos/gerarprocesso`,JSON.stringify(this.registroProcesso)).then(res => {
                this.limparDados()
                this.exibirTelaGerarProcesso = false;
                this.$toast.add({severity: 'success', summary: 'Processo Gerado', detail: 'Protocolo: ' + res.data, life: 3000});
            })
        },
        showModal(dados){
            this.registro = getDefaulValida(),
            this.registro.descJustificativa = ""
            this.dadosAprovacao = dados
            this.exibirTelaValidacaoPendente = true
            if(this.mostrarDeferidos){
                this.registro.statusProgramacao = { idenStatusProgramacao:{name: 'Não', code: "N"}  }
            }
        },  
        showModalDataFerias(dados){
            this.limparDados()
            this.dadosFerias = dados
            this.$http.get(`${baseApiUrl}/direitoafastamentos/${this.dadosFerias.idenDireitoAfastamento}`).then(res => {
                this.tiposGozo = []
                this.selectedTipoGozo = null
                this.saldoDias = res.data.qtdeSaldoDias + " dias"
                for(var item in res.data.periodoAfastamento) {
                    var v_tiposGozo = {
                        'name' : res.data.periodoAfastamento[item].dias+" dias",
                        'code' : res.data.periodoAfastamento[item].dias
                    }
                    this.tiposGozo.push(v_tiposGozo)
                }
                this.selectedTipoGozo = this.tiposGozo[0]
                this.calcularData();
                this.exibirTelaNovaFerias = true
            })
        },      
        showModalGerarProcesso(){
            this.registroProcesso = getDefaulGerarProcesso()
            this.exibirTelaGerarProcesso = true
        },   
        validaRegistro(){           
            
            if(this.registro.statusProgramacao.idenStatusProgramacao.code  == "N" && this.registro.descJustificativa == ""){
                    this.$toast.add({severity:'error', summary: "A justificativa é OBRIGATORIA quando o pedido de Férias for negado", life: 3000})
                    return
            }

            if(this.registro.statusProgramacao.idenStatusProgramacao.code == "S"){
                this.registro.statusProgramacao.idenStatusProgramacao = 6 // aprovado
            }else{
                this.registro.statusProgramacao.idenStatusProgramacao = 3 // reprovado               
            }

            this.registro.numrMatriculaChefe = this.$store.getters.getMatricula
            this.registro.numrVinculoChefe = this.$store.getters.getVinculo
            this.registro.direitoAfastamento.idenDireitoAfastamento = this.dadosAprovacao.idenProgramacaoAfastamento
            this.$http.put(`${baseApiUrl}/${this.apiUrlRecurso}/validacao/${this.dadosAprovacao.idenProgramacaoAfastamento}/${this.dadosAprovacao.numrMatricula}/${this.dadosAprovacao.numrVinculo}`,JSON.stringify(this.registro)).then(() => {
                if(this.registro.statusProgramacao.idenStatusProgramacao == 2){
                    this.$toast.add({severity:'success', summary: 'Agendamento aprovado com Sucesso! Informações encaminhadas por email', life: 3000})
                }
                this.exibirTelaValidacaoPendente = false
                this.carregarDados()
            })

        },        
        calcularData(){
            if(this.selectedTipoGozo){
                if(this.data_inicio){
                    let checkData = this.data_inicio.replace('_','')
                    checkData = checkData.replace('_','')
                    checkData = checkData.replace('_','')
                    checkData = checkData.replace('_','')
                    checkData = checkData.replace('_','')
                    checkData = checkData.replace('_','')
                    checkData = checkData.replace('_','')
                    checkData = checkData.replace('_','')
                    checkData = checkData.replace('/','')
                    checkData = checkData.replace('/','')
                    checkData = checkData.split('')
                    if(checkData.length > 7){
                        let data_i = new moment(this.data_inicio,'DD/MM/YYYY').locale('pt-br')
                        let qtd_dias = this.selectedTipoGozo.code - 1
                        let data_f = data_i.locale('pt-br').add(qtd_dias,'days')
                        this.data_fim = data_f.locale('pt-br').format('L')
                    }else{
                        this.data_fim = null
                    }
                    
                    if(this.selectedTipoGozo.code<30){
                        this.checkReducaoJornada=false
                    }
                }                
            }
            
        },        
        adicionarRegistro(){

            if(this.data_inicio==null){
                this.$toast.add({severity: 'error', summary: 'Dados Ausentes', detail: 'Informe a data de início', life: 4000});
            } else {
                var v_tipoJornada = this.checkReducaoJornada==true ? "REDUZIDA" : "INTEGRAL"
                var programacaoAdicionada = {
                    direitoAfastamento : {idenDireitoAfastamento:this.dadosFerias.idenDireitoAfastamento},
                    dataInicio : this.data_inicio,
                    dataFim : this.data_fim,
                    tipoJornada : v_tipoJornada,
                    qtdDiasAfastamento: this.selectedTipoGozo.code
                }

                this.$http.post(`${baseApiUrl}/programacaoafastamentos`, JSON.stringify(programacaoAdicionada))
					.then(() => {
                        this.$toast.add({severity:'success', summary: 'Registro Adicionado com Sucesso!', life: 3000})
                        this.selectedTipoGozo.code = null
                        this.exibirTelaNovaFerias = false
						this.limparDados()
						this.carregarDados()
                    })
                    //.catch(error => {
                    //    for(let i=0;i<error.response.data.length;i++){
                    //        this.$toast.add({severity:'error', summary:error.response.data[i].msgUsuario, life: 3000})
                    //    }
                    //})
            }
        },
        buscaServidor(){ 
            this.$toast.removeAllGroups();
            this.dadosBusca.parametroPesquisa = this.dadosBusca.parametroPesquisa? this.dadosBusca.parametroPesquisa.trim(): null;
            this.dadosBusca.dataBusca = this.dadosBusca.dataBusca!=''? this.dadosBusca.dataBusca: null;
            if (this.mostrarNaoAgendados) {
                this.apiUrlRecurso = 'direitoafastamentos';
                this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/naoagendados/${this.escalaAnualRhSelecionada}?size=10&page=0`,JSON.stringify(this.dadosBusca)).then((res) => {
                    this.dadosTabela = res.data.content;
                    this.totalRecords =  res.data.totalElements;
                });
            } else {
                this.apiUrlRecurso = 'programacaoafastamentos';
                if (this.mostrarPendentes) {
                    this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/pendentes/${this.escalaAnualRhSelecionada}?size=10&page=0`,JSON.stringify(this.dadosBusca)).then((res) => {
                        this.dadosTabela = res.data.content;
                        this.totalRecords =  res.data.totalElements;
                    });
                } else if (this.mostrarDeferidos) {
                    this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/aprovados/${this.escalaAnualRhSelecionada}?size=10&page=0`,JSON.stringify(this.dadosBusca)).then((res) => {
                        this.dadosTabela = res.data.content;
                        this.totalRecords =  res.data.totalElements;
                    });
                } else if (this.mostrarPublicadoseap) {
                    this.$http.post(`${baseApiUrl}/${this.apiUrlRecurso}/rh/licencapremio/publicadoseap/${this.escalaAnualRhSelecionada}`,JSON.stringify(this.dadosBusca)).then((res) => {
                        this.dadosTabela = res.data.content;
                        this.totalRecords =  res.data.totalElements;
                    });
                }    
            } 
        },
        alteraStatusProgramacao(data,status='validado'){
            this.apiUrlRecurso = 'programacaoafastamentos';
            this.$http.put(`${baseApiUrl}/${this.apiUrlRecurso}/${data.idenProgramacaoAfastamento}/${status}`).then(() => {
                this.carregarDados();
            });

        },
        voltarPagina(){
            this.$router.push({name:'cadEscala'})
        },
        encerrarEscala(){
        this.$http.put(`${baseApiUrl}/escalaafastamentos/encerrar`,JSON.stringify(this.escala)).then(() => {
            this.voltarPagina()
        });
        }
    },
    computed:{
        estiloPendentes(){
            return{
                'estiloPendentes':this.mostrarPendentes,
                'estiloOff':this.mostrarDeferidos || this.mostrarNaoAgendados,
            }
        },
        estiloDeferidos(){
            return{
                'estiloDeferidos':this.mostrarDeferidos,
                'estiloOff':this.mostrarPendentes || this.mostrarNaoAgendados,
            }
        },
        estiloNaoAgendados(){
            return{
                'estiloDeferidos':this.mostrarNaoAgendados,
                'estiloOff':this.mostrarPendentes || this.mostrarDeferidos,
            }
        },
        textoBusca() {
            if (this.mostrarPendentes) {
                return 'Agendamentos Pendentes';
            } else if (this.mostrarDeferidos) {
                return 'Agendamentos Deferidos';
            } else if (this.mostrarNaoAgendados) {
                return 'Não Agendados';
            } else if (this.mostrarPublicadoseap) {
                return 'No SEAP';
            } else {
                return '';
            }
        }
    },
    mounted(){
        this.alternarPaginas('pendentes')
    }
    
}
</script>
<style scoped>
    .estiloPendentesReduzido{
        color: #d59800;
    }
    .estiloPendentes {
    background: rgb(219, 171, 81);
    color: aliceblue;
    }
    .estiloDeferidos {
    background: #0ca852;
    color: aliceblue;
    }
    .estiloNaoAgendados {
    background: #f03a3a;
    color: aliceblue;
    }
    .estiloPublicoSEAP {
    background: #005494;
    color: aliceblue;
    }
    .estiloOff {
    background: #ccc;
    color: grey;
    }
    .status-APROVADORH {
        background-color: #C8E6C9;
        color: #256029;
        width: 70%;
    }
    
    .status-APROVADORH:active {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        
    
    .status-APROVADORH:hover {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        
    
    .status-APROVADORH:focus {
        box-shadow: 0 0 0 0.2rem #c8e6c9 ;
    }

    .status-APROVADO {
        background-color: #C8E6C9;
        color: #256029;
        width: 70%;
    }

    .status-APROVADO:active {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        

    .status-APROVADO:hover {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        

    .status-APROVADO:focus {
        box-shadow: 0 0 0 0.2rem #c8e6c9 ;
    }

    .status-REPROVADO {
        background-color: #FFCDD2;
        color: #C63737;
        width: 70%;
    }

    .status-REPROVADO:active {
        background-color: #FFCDD2 !important;
        color: #C63737 !important;
    }        

    .status-REPROVADO:hover {
        background-color: #FFCDD2 !important;
        color: #C63737 !important;
    }        

    .status-REPROVADO:focus {
        box-shadow: 0 0 0 0.2rem #FFCDD2 ;
    }

    .status-PENDENTE {
        background-color: #FEEDAF;
        color: #8A5340;
        width: 70%;
    }

    .status-PENDENTE:active {
        background-color: #FEEDAF !important;
        color: #8A5340 !important;
    }        

    .status-PENDENTE:hover {
        background-color: #FEEDAF !important;
        color: #8A5340 !important;
    }        

    .status-PENDENTE:focus {
        box-shadow: 0 0 0 0.2rem #FEEDAF ;
    }

    .status-PUBLICADO {
        background-color: #B3E5FC;
        color: #23547B;
        width: 70%;
    }

    .status-PUBLICADO:active {
        background-color: #B3E5FC !important;
        color: #23547B !important;
    }        

    .status-PUBLICADO:hover {
        background-color: #B3E5FC !important;
        color: #23547B !important;
    }        

    .status-PUBLICADO:focus {
        box-shadow: 0 0 0 0.2rem #B3E5FC ;
    }

    .status-VALIDADO {
        background-color: #ECCFFF;
        color: #694382;
        width: 70%;
    }

    .status-VALIDADO:active {
        background-color: #ECCFFF !important;
        color: #694382 !important;
    }        

    .status-VALIDADO:hover {
        background-color: #ECCFFF !important;
        color: #694382 !important;
    }        

    .status-VALIDADO:focus {
        box-shadow: 0 0 0 0.2rem #ECCFFF ;
    }

    .status-AGENDADO_PARCIAL {
        background-color: #e0e79d;
        color: #8A5340;
        width: 70%;
    }

    .status-AGENDADO_PARCIAL:active {
        background-color: #e0e79d !important;
        color: #8A5340 !important;
    }        

    .status-AGENDADO_PARCIAL:hover {
        background-color: #e0e79d !important;
        color: #8A5340 !important;
    }        

    .status-AGENDADO_PARCIAL:focus {
        box-shadow: 0 0 0 0.2rem #e0e79d ;
    }

.botao-status{
    /*width:155px; */
    margin:5px; 
    border:0; 
    font-weight: bold;
    font-size: 13px;
}

.botao-acao{
    margin:5px; 
    font-size: 13px;
    /*width:145px;*/
}

.button-badge {
    position: absolute;
    font-size: 10px;
    right: -5px;
    top: -5px;
    min-width: 20px;
    min-height: 18px;
    text-align: center;
    line-height: 18px;
    color: #fff;
    background-color: #ef6262;
    padding: 2px;
    border-radius: 50%;
}

.setor-badge {
    display: inline-block;
    margin-left: 4px;
    font-size: 13px;
    min-width: 20px;
    min-height: 18px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    background-color: #007be5;
    border-radius: 50%;
    padding: 2px;
}
.botao-titulo-status{    
    font-size: 15px;
    font-weight: bold;
}
.botao-quantidade-status{    
    background-color: #007be5;
    color: aliceblue;
    padding: 5px;
    font-size: 20px;
}
.card-button{    
    cursor: pointer;
}
</style>

<style>
    .situacaoColunaFeriasAgendamento >div {
        justify-content: center;
    }
    .botaoColunaSituacaoFeriasAgendamento{
        text-align: center !important;
    }
</style>